import { ConfigProvider, Input, Row, Space, Table, Typography } from "antd"
import PageSidebar from "../common/PageSidebar"
import VSpace from "../common/VSpace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faFolder, faPaperclip, faRotate } from "@fortawesome/pro-solid-svg-icons"
import ThemableButton from "../Items/ThemableButton"
import { useEffect, useState } from "react"
import { grey } from "@ant-design/colors"
import SidebarCreateButton from "../common/SidebarCreateButton"
import { filterFolders, findMatchingFolder } from "./attachmentsModel"
import { useAttachmentFolders, useAttachmentsInvalidator } from "./attachmentsQueries"
import AttachmentUpload from "./AttachmentUpload"

const { Text, Link } = Typography

type Props = {
  selectedFolderId: string | undefined
  customerId: number,
  propertyId?: number
  jobId?: number
  onFolderSelect: (folderId: string | undefined, jobId?: number) => void
  initialFolder?: string
  backUrl: string
}

const AttachmentsSidebar = ({selectedFolderId, customerId, propertyId, jobId, onFolderSelect, initialFolder, backUrl}: Props) => {
  const foldersQuery = useAttachmentFolders(customerId, propertyId)
  const invalidator = useAttachmentsInvalidator()
  const [search, setSearch] = useState('')
  const [didHandleInitialFolder, setDidHandleInitialFolder] = useState(false)
  const [isUploadOpen, setIsUploadOpen] = useState(false)

  useEffect(() => {
    if (initialFolder && !didHandleInitialFolder && foldersQuery.data) {
      setDidHandleInitialFolder(true)
      const match = findMatchingFolder(foldersQuery.data ?? [], initialFolder)
      if (match) {
        onFolderSelect(match.id, match.jobId)
      }
    }
  }, [foldersQuery.data, initialFolder])
  
  const filteredFolders = filterFolders(foldersQuery.data ?? [], search)

  

  return <PageSidebar>
    <VSpace size="large">
      <VSpace style={{padding: '10px 10px 0 10px'}}>
        <Row justify="space-between" align="middle">
          <Space>
            <Link style={{color: 'white'}} href={backUrl}><FontAwesomeIcon icon={faArrowLeft}/></Link>
            <Text style={{ color: 'white', fontSize: 18, fontFamily: 'Open Sans, sans-serif'}}>Attachments</Text>
          </Space>
          <ThemableButton type="link" colorLink={grey[2]} icon={<FontAwesomeIcon icon={faRotate} />} onClick={() => invalidator.invalidateAllFolders()} />
        </Row>
        <Row>
          <Input.Search placeholder="Search" value={search} onChange={x => setSearch(x.target.value ?? '')} allowClear />
        </Row>
      </VSpace>

      <SidebarCreateButton text="Upload Attachments" onClick={() => setIsUploadOpen(true)} />
      <AttachmentUpload
        isOpen={isUploadOpen}
        customerId={customerId}
        propertyId={propertyId}
        jobId={jobId}
        defaultFolder={selectedFolderId ?? ''}
        onClose={() => {
          setIsUploadOpen(false)
        }}
      />

      <div className="react-scrollable-list" style={{
        height: `calc(100vh - 192px)`
      }}>
        <ConfigProvider theme={{
          components: {
            Table: {
              colorBgContainer: '#3d587f',
              borderColor: '#3d587f',
              rowHoverBg: '#4a6b9a',
              colorText: 'white'
            }
          }
        }}>
          <Table
            size="small"
            pagination={false}
            dataSource={filteredFolders}
            loading={foldersQuery.isFetching}
            showHeader={false}
            rowKey={x => x.id}
            onRow={(folder) => {
              return {
                style: {
                  cursor: 'pointer',
                  backgroundColor: selectedFolderId === folder.id ? '#4a6b9a' : undefined
                },
                onClick: () => onFolderSelect(folder.id, folder.jobId)
              }
            
            }}
            columns={[
              {
                render: (_, folder) => <>
                  <div>
                    <Space>
                      <FontAwesomeIcon icon={faFolder} />
                      {folder.folder}
                    </Space>
                  </div>
                  <small style={{color: '#fafafa80'}}>
                    <Space>
                      <FontAwesomeIcon icon={faPaperclip} />
                      <span>{folder.files} {folder.files === 1 ? 'file' : 'files'}</span>
                    </Space>
                  </small>
                </>
              }
            ]}
          />
        </ConfigProvider>
      </div>
    </VSpace>
  </PageSidebar>
}

export default AttachmentsSidebar